import { useEffect, useState } from "react";
import styles from "./TabGroup.module.scss";
import PropTypes from "prop-types";
import classNames from "classnames";

const TabGroup = ({
  tabs,
  defaultId,
  onTabChange,
  className,
  tabButtonClassName,
  alignLeft = false,
  borderBottom = false,
}) => {
  const [activeId, setActiveId] = useState(defaultId || tabs[0].id);

  useEffect(() => {
    if (onTabChange) {
      onTabChange(activeId);
    }
  }, [activeId, onTabChange]);

  return (
    <div className={classNames(styles.tabsContainer, className)} aria-label="Tab Group">
      <div
        className={`${styles.tabs} ${alignLeft ? styles.noGrow : ""} ${borderBottom ? styles.borderBottom : ""}`}
      >
        {tabs.map((tab) => (
          <button
            key={tab.id}
            className={`${styles.tabButton} ${tab.id === activeId ? styles.active : ""} ${tabButtonClassName || ""}`}
            onClick={() => setActiveId(tab.id)}
          >
            {tab.label}
          </button>
        ))}
      </div>

      <div className={styles.tabContents}>
        {tabs.map((tab) => {
          const TabComponent = tab.component;
          const isActive = tab.id === activeId;

          return (
            <div
              key={tab.id}
              className={styles.tabContainer}
              style={{ display: isActive ? "" : "none" }}
            >
              {TabComponent ? <TabComponent /> : null}
            </div>
          );
        })}
      </div>
    </div>
  );
};

TabGroup.propTypes = {
  tabs: PropTypes.array.isRequired,
  defaultId: PropTypes.string,
  onTabChange: PropTypes.func,
  className: PropTypes.string,
  tabButtonClassName: PropTypes.string,
  alignLeft: PropTypes.bool,
  borderBottom: PropTypes.bool,
};

export default TabGroup;
